import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TrackByFunction,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '../../../../core/modal/modal.service';
import { UtilsService } from '../../../../core/services/utils.service';
import { ListModalComponent } from '../../../../shared/components/modals/list-modal/list-modal.component';
import { Selected } from '../../../../shared/selected.pipe';
import { GroupsApiService } from '../../../../core/modules/groups/groups-api.service';
import { Group } from '../../../../core/modules/groups/groups.types';

type GroupWithSelectedState = (Group & Selected);

@UntilDestroy()
@Component({
  selector: 'tax-user-groups',
  templateUrl: 'user-groups.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UserGroupsComponent implements OnInit {
  @Input() set selectedGroupsIds(selectedGroupsIds: number[] | undefined) {
    if (!selectedGroupsIds) {
      return;
    }

    this._selectedGroupsIds = selectedGroupsIds;
    this.groups = this.setStateSelected(this.groups, selectedGroupsIds);
    this.cdr.detectChanges();
  }

  @Output() groupsChanges = new EventEmitter<number[]>();

  readonly trackById: TrackByFunction<GroupWithSelectedState> = this.utilsService.trackById;

  groups: GroupWithSelectedState[] = [];

  private _selectedGroupsIds: number[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private modalService: ModalService,
    private groupsApiService: GroupsApiService,
    private utilsService: UtilsService,
  ) {
  }

  ngOnInit(): void {
    this.setGroups();
  }

  selectGroupsModal(groups: GroupWithSelectedState[]): void {
    this.modalService.openOld<GroupWithSelectedState[]>(
      ListModalComponent,
      {
        type: 'groups',
        items: groups,
      },
      {
        width: '740px',
      },
    )
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        this.groups = result;
        this.cdr.detectChanges();

        const selectedGroupsIds = result
          .filter(group => group.selected)
          .map(group => group.id);
        this.groupsChanges.emit(selectedGroupsIds);
      });
  }

  private setGroups(): void {
    this.groupsApiService.fetchGroups(0, '')
      .pipe(untilDestroyed(this))
      .subscribe((groups) => {
        this.groups = this.setStateSelected(groups, this._selectedGroupsIds);
        this.cdr.detectChanges();
      });
  }

  private setStateSelected(groups: GroupWithSelectedState[], selectedGroupsIds: number[]): GroupWithSelectedState[] {
    selectedGroupsIds.forEach((selectedGroupId) => {
      const selectedGroup = groups.find(group => group.id === selectedGroupId);
      if (selectedGroup) {
        selectedGroup.selected = true;
      }
    });

    return groups;
  }
}
